import { render, staticRenderFns } from "./agree2_popup.vue?vue&type=template&id=2c153e24&scoped=true&"
import script from "./agree2_popup.vue?vue&type=script&lang=js&"
export * from "./agree2_popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c153e24",
  null
  
)

export default component.exports